// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"forest"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 15.9995L7 2.99951L2 15.9999L12 15.9995Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M12 15.9995L17 2.99951L22 15.9999L12 15.9995Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 15.9995L17 2.99951L22 15.9999L12 15.9995ZM12 15.9995L7 2.99951L2 15.9999L12 15.9995ZM7 4L7 21M17 4V21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-forest')
export default class ForestIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'forest',
    }
  }
}
